export default "__VITE_ASSET__v$LFcLn8__"